import get from 'lodash/get';
import ngCreditCards from 'angular-credit-cards';

import { PhoneInputDirectiveModule } from 'directives/phoneInput.directive';
import { ValidatePhoneDirectiveModule } from 'directives/validatePhone.directive';
import { ValidatePasswordDirectiveModule } from 'directives/validatePassword.directive';
import { ValidateEmailDirectiveModule } from 'directives/validateEmail.directive';
import { CheckEmailDirectiveModule } from 'directives/checkEmail.directive';
import { PaymentServiceModule } from 'services/payment/payment.service';
import { DataLayerServiceModule } from 'services/tracking/enhancedEcommerce/dataLayer.service';
import { STATES_US } from 'app/constants';

import { CreditCardUtilitiesServiceModule } from 'services/utilities/creditCardUtilities.service';
import { CreditCardsModule } from 'components/creditCards/creditCards.module';
import { GoogleAutoComplete } from 'components/googleAutocomplete/googleAutocomplete';
import template from './signupForm.html';
import './signupForm.scss';

export const CheckoutSignupFormModule = angular
    .module('app.components.checkout.components.checkoutSignupForm', [
        ngCreditCards,
        CreditCardUtilitiesServiceModule,
        CreditCardsModule,
        PhoneInputDirectiveModule,
        ValidatePhoneDirectiveModule,
        ValidatePasswordDirectiveModule,
        ValidateEmailDirectiveModule,
        CheckEmailDirectiveModule,
        PaymentServiceModule,
        DataLayerServiceModule,
        GoogleAutoComplete
    ]).component('checkoutSignupForm', {
        template,
        bindings: {
            couponData: '<coupon',
            couponCode: '<',
            user: '<',
            onValidityChange: '&',
            isEditMode: '<',
            onCouponEntered: '&',
            onPaymentMethodSelected: '<',
            showCouponField: '<',
            purchaseComplete: '<'
        },
        controller: class CheckoutSignupFormCtrl {
            constructor(creditCardUtilities, $scope, paymentService, dataLayer, $q) {
                'ngInject';

                angular.extend(this, {
                    card: {
                        ccClass: 'credit-card-img--unknown'
                    },
                    AUTOCOMPLETE_COUNTRIES: ['US'],
                    creditCardUtilities,
                    $scope,
                    STATES_US,
                    paymentService,
                    dataLayer,
                    $q
                });
            }

            $onInit() {
                this.onToggleEditMode = this.onToggleEditMode.bind(this);

                this.$scope.$watch('signupForm.$valid', (newValue) => {
                    if (angular.isDefined(newValue)) {
                        this.onValidityChange({ isValid: newValue });
                    }
                });
            }

            $onChanges(changesObject) {
                if (get(changesObject, 'user.currentValue.newPayment.brand')) {
                    this.setCardInfo(this.user.newPayment.brand);
                }

                if (get(changesObject, 'couponCode.currentValue')) {
                    this.showCouponCodeInput = true;
                    this.user.couponCode = this.couponCode;
                    this.validateCoupon(this.couponCode);
                }

                if (get(changesObject, 'couponData.currentValue.id')) {
                    this.user.couponCode = this.couponData.id;
                    this.showCouponCodeInput = true;
                }
            }

            setCardInfo(cardType) {
                this.card.ccClass = this.creditCardUtilities.getCssClass(cardType);
                this.card.brand = cardType;
            }

            toggleEditMode() {
                this.isEditMode = !this.isEditMode;
                this.setCardInfo(this.user.newPayment.brand);
            }

            inputNeedsAttention(input) {
                return { 'v-input--error': input.$invalid && input.$dirty && input.$touched && input.$invalid };
            }

            setCouponCodeValidity(isValid) {
                if (get(this, '$scope.signupForm.couponCode')) {
                    this.$scope.signupForm.couponCode.$setDirty();
                    this.$scope.signupForm.couponCode.$setTouched();
                    this.$scope.signupForm.couponCode.$setValidity('couponValid', isValid);
                }
            }

            validateCoupon(coupon) {
                this.applyingCouponCode = true;
                return this.paymentService.stripe.validateCoupon(coupon).then((response) => {
                    if (!response.valid) return this.$q.reject();
                    this.setCouponCodeValidity(true);
                    this.couponData = Object.assign({}, response, { id: coupon });
                    this.onCouponEntered({ coupon: this.couponData });
                }).catch(() => {
                    this.setCouponCodeValidity(false);
                    this.dataLayer.logCouponError(coupon);
                }).finally(() => {
                    this.applyingCouponCode = false;
                });
            }

            clearCoupon() {
                this.couponData = null;
                this.user.couponCode = '';
                this.onCouponEntered({ coupon: null });
            }

            onCouponCodeChanged() {
                this.$scope.signupForm.couponCode.$setValidity('couponValid', true);
            }

            onToggleEditMode() {
                this.isEditMode = !this.isEditMode;
            }
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/components/checkout/components/signupForm/signupForm.js